/**
 * RegionDetailPage — full single-region view (BON-153), built from the design
 * bundle's region-detail.jsx. Territory map + subregions + member venues on the
 * left; region profile (composition + assignable director), recent activity
 * (mocked — no backend audit feed yet), and the danger zone on the right.
 * Route: /admin/regions/:id.
 */
import { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BucketError, BucketLoading } from '../../regional/BucketStates';

import { RegionCreateModal } from './RegionCreateModal';
import { RegionDetailGrid } from './RegionDetailGrid';
import { RegionDetailHeader } from './RegionDetailHeader';
import {
  useRegionTree,
  useRegionDetail,
  useRegionComponents,
  useRegionBoundary,
  useRegionVenues,
} from './regionsQueries';

export default function RegionDetailPage() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const treeQ = useRegionTree();
  const detailQ = useRegionDetail(id);
  const componentsQ = useRegionComponents(id);
  const boundaryQ = useRegionBoundary(id);
  const venuesQ = useRegionVenues(id);
  const [adding, setAdding] = useState(false);

  const regions = useMemo(() => treeQ.data ?? [], [treeQ.data]);

  if (detailQ.isLoading || treeQ.isLoading) return <BucketLoading />;
  if (detailQ.isError) return <BucketError error={detailQ.error} />;
  const detail = detailQ.data;
  if (!detail) return <BucketError error={detailQ.error} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, minHeight: 0 }}>
      <RegionDetailHeader
        name={detail.name}
        parentName={detail.parentName}
        editTo={`/admin/regions/${detail.id}/edit`}
        onAddSubregion={() => setAdding(true)}
      />

      <RegionDetailGrid
        detail={detail}
        regions={regions}
        boundary={boundaryQ.data}
        components={componentsQ.data}
        venues={venuesQ.data}
        onGone={() => navigate('/admin/regions')}
      />

      {adding && (
        <RegionCreateModal
          regions={regions}
          initialParentId={detail.id}
          onClose={() => setAdding(false)}
          onCreated={(newId) => {
            setAdding(false);
            navigate(`/admin/regions/${newId}`);
          }}
        />
      )}
    </div>
  );
}
